declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_chaining_foo extends $mol_object {
		c( next?: any ): any
		b( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_chaining_foo['c'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_chaining_foo['c'] >
		a( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_chaining_foo['b'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_chaining_foo['b'] >
	}
	
}

//# sourceMappingURL=bidi_chaining.view.tree.d.ts.map